import Vue from 'vue';
import store from './../../store';

// When the request succeeds
const success = () => {
  store.dispatch('customer/getCustomer');
};

// When the request fails
const failed = () => {};

export default (customer, cb) => {
  if (
    !customer.name
  ) {
    failed();
  } else {
    customer.customerGroupId = customer.customerGroup;
    Vue.$http
      .post('Customers', customer)
      .then((response) => {
        if (cb) cb(null, response);
        success(response);
      })
      .catch((error) => {
        if (cb) cb(error);
        failed(error);
      });
  }
};



// WEBPACK FOOTER //
// ./src/services/customer/create.js